import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { FieldType } from '@ngx-formly/core';
import { ClipboardService } from 'ngx-clipboard';
import { ButtonModule } from 'primeng/button';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputTextModule } from 'primeng/inputtext';
import { I18nService } from '../../../@core/services/i18n/i18n.service';
import { NotificationService } from '../../../@core/services/notification/notification.service';

@Component({
  selector: 'app-mail-input',
  // changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './formly-mail-input.component.html',
  standalone: true,
  imports: [
    InputTextModule,
    ButtonModule,
    ReactiveFormsModule,
    InputGroupModule,
  ]
})
export class FormlyMailInput extends FieldType implements OnInit, AfterViewInit {

  constructor(private cdRef: ChangeDetectorRef, private i18nService: I18nService,
    private clipboardService: ClipboardService, private notificationService: NotificationService,
    private router: Router) {
    super();
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.init();
  }

  async init() {
    this.cdRef.detectChanges();
  }

  copyToClipboard(text: string) {
    this.clipboardService.copyFromContent(text);
    this.notificationService.success(_("common.copied-to-clipboard"), { entity: "company" });
  }

  openEmail() {
    this.router.navigate([]).then(res => {
      window.open("mailto:" + this.formControl.value)
    })
  }

  btnClick(e) {
    this.openEmail()
  }

  getDataTestId(): string {
    if (!this.field?.props?.attributes || this.field.props.attributes['data-testid'] === undefined) {
      return "formly-mail";
    }
    else {
      let dataTestId = this.field?.props?.attributes['data-testid'] as string;
      return dataTestId;
    }
  }


}
